export enum SystemNotificationsDetailsEnum {
    createdBy,
    createdDate,
    lastModifiedBy,
    lastModifiedDate
}
